import React from 'react'

import ResumePdf from 'url:../assets/Resume.pdf'
import CvPdf from 'url:../assets/Gabriel-Huayamabe-cv.pdf'
import profilePhoto from 'url:../assets/gabriel-huayamabe.jpg'

export default function Hero({ profile, t, go, lang }) {
  return (
    <section className="hero">
      <div className="container hero-grid">
        <div>
          <p className="eyebrow">{t.eyebrow}</p>

          <h1>
            Gabriel
            <br />
            <em>Huayamabe</em>
          </h1>

          <h2>{profile.role[lang]}</h2>

          <p className="lead">{profile.summary[lang]}</p>

          <div className="hero-buttons">
            <button className="primary" onClick={() => go('projects')}>
              {t.work} <span>→</span>
            </button>

            <a
              className="secondary"
              href={lang === 'en' ? ResumePdf : CvPdf}
              download={
                lang === 'en' ? 'Resume.pdf' : 'Gabriel-Huayamabe-cv.pdf'
              }
            >
              {t.cv} <span>↓</span>
            </a>
          </div>

          <div className="hero-meta">
            <div>
              <b>⌖</b>
              <span>
                {profile.location}
                <small>
                  {lang === 'en' ? 'Based in Ecuador' : 'Ubicado en Ecuador'}
                </small>
              </span>
            </div>

            <div>
              <b>▱</b>
              <span>
                {profile.availability[lang]}
                <small>
                  {lang === 'en'
                    ? 'Available worldwide'
                    : 'Disponible globalmente'}
                </small>
              </span>
            </div>

            <div>
              <b>11+</b>
              <span>
                {lang === 'en' ? 'Years' : 'Años'}
                <small>
                  {lang === 'en'
                    ? 'Professional experience'
                    : 'Experiencia profesional'}
                </small>
              </span>
            </div>
          </div>
        </div>

        <div className="hero-art">
          <div className="portrait">
            <img src={profilePhoto} alt="Gabriel Huayamabe" />
          </div>

          <div className="badge">
            <b>{profile.years}</b>
            <span>
              {lang === 'en' ? 'Years of' : 'Años de'}
              <br />
              {lang === 'en' ? 'Experience' : 'Experiencia'}
            </span>
          </div>

          <div className="code-card">
            <b>&lt;/&gt;</b>
            <span>{lang === 'en' ? 'Clean code.' : 'Código limpio.'}</span>
            <strong>{lang === 'en' ? 'Real impact.' : 'Impacto real.'}</strong>
          </div>

          <div className="vertical">
            DEVELOP
            <br />
            INNOVATE
            <br />
            DELIVER
          </div>
        </div>
      </div>
    </section>
  )
}
